/**
 * Configuration Types - Bolt Connection
 *
 * Bolt connection configuration types
 */

import type { FormField } from '../ui';
import type {
  ConnectorParameterBindingKind,
  ConnectorParameterDestination,
} from './connector.types';

export const BOLT_PROJECT_PARAMETER_CATEGORY_OPTIONS = [
  'Pipes',
  'Pipe Fittings',
  'Pipe Accessories',
  'Generic Models',
  'Mechanical Equipment',
] as const;

export type BoltProjectParameterCategory =
  (typeof BOLT_PROJECT_PARAMETER_CATEGORY_OPTIONS)[number];

export const DEFAULT_BOLT_PROJECT_PARAMETER_CATEGORIES: BoltProjectParameterCategory[] = [
  'Pipe Accessories',
];

// =============================================================================
// Bolt Configuration
// =============================================================================

/**
 * Bolt connection page configuration
 */
export interface BoltConfiguration {
  /** Where bolt parameters should be created */
  parameterDestination: ConnectorParameterDestination;
  /** Whether bolt parameters are type or instance scoped */
  parameterBindingKind: ConnectorParameterBindingKind;
  /** Project categories used when bolt parameters are created as project parameters */
  projectParameterCategories: BoltProjectParameterCategory[];
  /** Bolt modeling choice */
  boltModelingChoice: FormField;
  /** Bolt base family value */
  boltBaseFamilyValue: FormField;
  /** Bolt set active value */
  boltSetActiveValue: FormField;
  /** Bolt item description value */
  boltItemDescriptionValue: FormField;
  /** Bolt diameter value */
  boltDiaValue: FormField;
  /** Bolt quantity value */
  boltQuantityValue: FormField;
  /** Bolt length value */
  boltLengthValue: FormField;
  /** Bolt material value */
  boltMaterialValue: FormField;
  /** Bolt standard value */
  boltStandardValue: FormField;
}

export type BoltConfigurationFormFieldKey = Exclude<
  keyof BoltConfiguration,
  'parameterDestination' | 'parameterBindingKind' | 'projectParameterCategories'
>;
